export default "__VITE_ASSET__4nreAkQs__"